import Page from "../../finwell/pages/Page";
import ComplianceReportSectionDetail from "../../components/Reports/complianceReport/ComplianceReportSectionDetail";

export const ComplianceReportDetailPage = () => {
    return (
      <Page>
        <ComplianceReportSectionDetail 
          isMobile={false}
        />
      </Page>
    );
  };
  
  export default ComplianceReportDetailPage;
  